import MainLayout from "../../components/layouts/MainLayout"
import React, { useEffect, useState } from "react";
import { DeleteFilled, EditFilled, EyeFilled, PlusOutlined, ReloadOutlined } from "@ant-design/icons";
import { Auth } from "../../utils/Auth";
import { message, Spin, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { DateFormat } from "../../utils/formatDate";
import { formationApi } from "../../api/formationApi";

const FormationList = () =>{

    const token = Auth.getSessionToken()
    const abortController = new AbortController()
    const [formations, setFormations] = useState([])
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const itemsPerPage = 15
    const [currentPage, setCurrentPage] = useState(1)
    const now = new Date();
    const date_now = now.getFullYear() + "-" + 
          String(now.getMonth() + 1).padStart(2, "0") + "-" + 
          String(now.getDate()).padStart(2, "0") + " " + 
          String(now.getHours()).padStart(2, "0") + ":" + 
          String(now.getMinutes()).padStart(2, "0") + ":" + 
          String(now.getSeconds()).padStart(2, "0");

     
    const handlefetchdata = async () => {
        setLoading(true)

        try {
            const res = await formationApi.getFormations(abortController.signal)
           
            if(!res){
                setLoading(false)
                   return;

            }            
            
            setFormations(res.data)
            setLoading(false)

         } catch (error) {
             console.log(error)

            setLoading(false)
            const messages = await error.messages ?? error.message;

          if(messages instanceof Array)
              return Swal.fire({
                title:messages.join('\n')!== 'Unauthenticated' ? "Erreur détectée" : "Session expirée",
                text:messages.join('\n')!== 'Unauthenticated' ? "Veuillez vous reconncter."  :  "Votre session a expirée veuillez vous reconnecter",
                icon:"error",
              }).then((result) => {
                if(messages.join('\n') === 'Unauthenticated'){
                    Auth.removeSessionToken()
                    return navigate(`/login`)
                }   
                        
              });

         }
    }

    const handleDetailQuiz = (formation) => {
        if(formation.id)
            return navigate(`/formation/${formation.id}/details-quiz`)
    }

    const handleEdit = (formation) => {
        if(formation.id)
            return navigate(`/formation/${formation.id}/edit`)
    }

    const handleAddFormation = () => {
        return navigate(`/formation/ajouter`)
    }

    const handleReactivate = async (formation) => {
        // Vérifier si la formation est expirée ou désactivée
        const isExpired = formation?.expired_at < date_now;
        const isDisabled = formation?.etat !== 1;
        // const isDeleted = formation?.deleted_at !== null;
        const canReactivate = isExpired || isDisabled;
        
        if (!canReactivate) {
            return message.warning("Cette formation est déjà active");
        }

        // Afficher la modale avec option de délai d'expiration
        const { value: formValues } = await Swal.fire({
            title: 'Réactiver la formation',
            html: `
                <div style="text-align: left;">
                    <p style="margin-bottom: 10px;">Voulez-vous définir une nouvelle date d'expiration ?</p>
                    <label style="display: block; margin-bottom: 5px; font-weight: 500;">Date d'expiration (optionnel) :</label>
                    <input 
                        id="delay_expiration" 
                        type="datetime-local" 
                        class="swal2-input" 
                        placeholder="Laisser vide pour réactiver sans expiration"
                        style="width: 100%; padding: 8px; border: 1px solid #ddd; border-radius: 4px;"
                    />
                    <p style="margin-top: 10px; font-size: 12px; color: #666;">
                        Laissez vide pour réactiver sans date d'expiration
                    </p>
                </div>
            `,
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: 'Réactiver',
            cancelButtonText: 'Annuler',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            preConfirm: () => {
                const delayExpiration = document.getElementById('delay_expiration').value;
                return {
                    delay_expiration: delayExpiration || ""
                };
            }
        });

        if (formValues) {
            try {
                setLoading(true);
                const res = await formationApi.reactivateFormation(
                    formation.id,
                    formValues.delay_expiration,
                    abortController.signal
                );

                if (!res.success) {
                    return Swal.fire({
                        title: "Erreur",
                        text: res.message || "Impossible de réactiver la formation",
                        icon: "error",
                    });
                }

                message.success("Formation réactivée avec succès");
                handlefetchdata(); // Rafraîchir la liste
            } catch (error) {
                console.error(error);
                message.error("Une erreur est survenue lors de la réactivation");
                const messages = await error.messages ?? error.message;

                if (messages instanceof Array) {
                    return Swal.fire({
                        title:
                            messages.join("\n") !== "Unauthenticated"
                                ? "Erreur détectée"
                                : "Session expirée",
                        text:
                            messages.join("\n") !== "Unauthenticated"
                                ? "Veuillez vous reconnecter."
                                : "Votre session a expirée veuillez vous reconnecter",
                        icon: "error",
                    }).then((result) => {
                        if (messages.join("\n") === "Unauthenticated") {
                            Auth.removeSessionToken();
                            return navigate(`/login`);
                        }
                    });
                }
            } finally {
                setLoading(false);
            }
        }
    };

    const handleDelete = async (formation) => {
        try {
            const res = await formationApi.deleteFormation(`${formation.id}`,abortController.signal)

            if (res.success === true) {
                message.success("Suppression effectuee avec succès !");
            }else{
                message.error(res.message);

            }

            handlefetchdata()
            
        } catch (error) {
            console.error(error);
            setLoading(false);
            message.error("Échec de suppression des informations");
        }
    }
    
    const indexOfLastItem = currentPage * itemsPerPage
    const indexOfFirstItem = indexOfLastItem - itemsPerPage
    const currentItems = formations.slice(indexOfFirstItem, indexOfLastItem);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    
    useEffect(() => {
            handlefetchdata()
        },[])
    
    return <MainLayout>
        <div className="container mx-auto p-4">
                <div className="flex justify-between items-center"> 
                    <h1 className="text-xl font-bold mb-4">Liste des formations</h1>
        
                    {/* Bouton Ajouter */}
                    <button
                        onClick={handleAddFormation}
                        className="px-4 py-2 text-white bg-africasa-secondary rounded hover:bg-africasa-primary flex items-center"
                    >
                        <PlusOutlined className="mr-2" />
                        Ajouter une formation
                    </button>
                </div>
        
                {/* Table */}
                <table className="min-w-full bg-white border border-gray-300">
                  <thead>
                    <tr className="bg-gray-200">
                      <th className="py-2 px-4 border-b text-left">#</th>
                      <th className="py-2 px-4 border-b text-left">Titre</th>
                      <th className="py-2 px-4 border-b text-left">Categorie</th>
                      <th className="py-2 px-4 border-b text-left">Status</th>
                      <th className="py-2 px-4 border-b text-left">Publie le</th>
                      <th className="py-2 px-4 border-b text-left">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                        <tr>
                        <td colSpan="6" className="text-sm text-center py-4">
                            Chargement des données en cours...
                        </td>
                        </tr>
                    ) : (
                      currentItems.map((formation, index) => {
                        const isExpired = formation?.expired_at < date_now;
                        const isDisabled = formation?.etat !== 1;
                        // const isDeleted = formation?.deleted_at !== null;
                        const canReactivate = isExpired || isDisabled;
                        
                        return (
                        <tr key={formation.id}>
                            <td className="py-2 px-4 border-b">{++index}</td>
                            <td className="py-2 px-4 border-b">
                            {formation?.title} 
                            </td>
                            <td className="py-2 px-4 border-b">{formation?.category?.libelle || ''}</td>
                            <td className="py-2 px-4 border-b">
                              
                                {!isExpired && formation?.etat === 1 ? (
                                    <span className="badge bg-green-600 text-white text-sm rounded-md p-1 flex items-center content-center">
                                        Active
                                    </span>
                                ) : (
                                    <span className="badge bg-red-600 text-white text-sm rounded-md p-1 flex items-center content-center">
                                        {isExpired ? 'Expiree' :  'Desactivee'}
                                    </span>
                                )}
                            </td>
                            <td className="py-2 px-4 border-b">{DateFormat.formatDate(formation?.created_at)  }</td>
                            
                            <td className="py-2 px-4 border-b">
                                <div className="flex items-center gap-2">
                                    {/* Icône Voir détails du quiz - uniquement si is_training === true */}
                                    {formation?.is_training === 1 && (
                                        <Tooltip title="Voir détails de la formation">
                                            <EyeFilled
                                                className="text-green-600 cursor-pointer hover:text-green-800"
                                                onClick={() => handleDetailQuiz(formation)}
                                            />
                                        </Tooltip>
                                    )}
                                    
                                    {/* Icône Modifier */}
                                    <Tooltip title="Modifier">
                                        <EditFilled 
                                            className="text-blue-600 cursor-pointer hover:text-blue-800" 
                                            onClick={() => handleEdit(formation)}
                                        />
                                    </Tooltip>
                                    
                                    {/* Icône Réactiver - uniquement pour les formations expirées/désactivées */}
                                    {canReactivate && (
                                        <Tooltip title="Réactiver la formation">
                                            <ReloadOutlined 
                                                className="text-orange-600 cursor-pointer hover:text-orange-800" 
                                                onClick={() => handleReactivate(formation)}
                                            />
                                        </Tooltip>
                                    )}
                                    
                                    {/* Icône Supprimer */}
                                    <Tooltip title="Supprimer">
                                        <DeleteFilled 
                                            className="text-red-600 cursor-pointer hover:text-red-800"
                                            onClick={() => handleDelete(formation)}
                                        />
                                    </Tooltip>
                                </div>
                            </td>
                        </tr>
                        )
                      })
                    )}
                    </tbody>
        
                </table>
                <div className="flex ml-0 space-x-2 mt-2 justify-end">
                    {Array.from({ length: Math.ceil(formations.length / itemsPerPage) }, (_, i) => (
                        <button 
                            key={i} 
                            onClick={() => paginate(i + 1)}
                            className={`px-3 py-1 border rounded ${currentPage === i + 1 ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
                        >
                            {i + 1}
                        </button>
                    ))}
                </div>
              </div>
    </MainLayout>
}
export default FormationList